import { Button, Spacer, Text } from '@oy/uidesktop';
import { DevConfigModal, PublicHeader } from 'src/components';
import { DevConfigBanner } from 'src/components/DevConfigBanner';
import { useDomainEnv, useTranslate } from 'src/hooks';
import styles from './LoginPage.module.css';
import { LoginFAQ, LoginForm, LoginMessage } from './components';
import { useLoginImpl } from './useLoginImpl';

const LoginPage = () => {
  const { actions, message, isSubmitting, isLoginSuperAdmin, showDevConfig } =
    useLoginImpl();

  const { getTranslation } = useTranslate();
  const { isDomainProdEnv } = useDomainEnv();

  const buildDevConfigButton = () => {
    return (
      !isDomainProdEnv && (
        <>
          <Spacer bottom={Spacer.Size.XL} />
          <Button
            name="devConfig"
            buttonType={Button.Type.Outlined}
            fullWidth
            onClick={() => actions.setShowDevConfig(true)}
          >
            Dev Config
          </Button>
        </>
      )
    );
  };

  return (
    <>
      <DevConfigModal
        isOpen={showDevConfig}
        onClose={() => actions.setShowDevConfig(false)}
      />
      <div className={styles.container}>
        <PublicHeader />
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.loginForm} id="formLogin">
              <DevConfigBanner />
              <Text textStyle={Text.Style.HeadingLg}>
                {getTranslation('common_login')}
              </Text>

              <Spacer bottom={Spacer.Size.XS} />
              <LoginMessage data={message} />
              <LoginForm
                isLoginSuperAdmin={isLoginSuperAdmin}
                isSubmitting={isSubmitting}
                onSubmit={actions.submitLogin}
              />
              <Spacer bottom={Spacer.Size.XL} />
              <div className={styles.register}>
                <Text textStyle={Text.Style.BodyMdRegular}>
                  {getTranslation('login_page_dontHaveAccount')}
                </Text>
                <Spacer right={Spacer.Size.XS} />
                <Button
                  name="register"
                  type="button"
                  buttonType={Button.Type.Outlined}
                  size={Button.Size.Small}
                  onClick={actions.onClickSignUp}
                >
                  {getTranslation('common_register')}
                </Button>
              </div>
              {buildDevConfigButton()}
            </div>
          </div>
          <div className={styles.spacer} />
          <div className={styles.right}>
            <div className={styles.faq}>
              <LoginFAQ />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
